import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

import Button from '../../../components/Button';
import { CardVertical } from '../../../components/CardProduct';
import { Loader } from '../../../components/Loader';

import './styles.sass';

const ProductsSection = ({
  title,
  page,
  btnNext,
  btnBack,
  onNext,
  onBack,
  statusAPI,
}) => {
  return (
    <section className="products-carousel">
      <h2>{title}</h2>
      <div className="products-carousel-list">
        {statusAPI ? (
          <>
            <Button
              className={
                btnBack ? 'btn btn-directional' : 'btn btn-directional none'
              }
              text={<FaAngleLeft />}
              onClick={onBack}
              aria-label="Voltar para a página anterior"
            />
            {page.map((product) => (
              <CardVertical
                key={product?.id}
                idProduct={product?.id}
                className="home"
                tag={product?.tag}
                image={product?.image}
                category={product?.category}
                name={product?.name}
                price={product?.price}
              />
            ))}
            <Button
              className={
                btnNext ? 'btn btn-directional' : 'btn btn-directional none'
              }
              text={<FaAngleRight />}
              onClick={onNext}
              aria-label="Ir para a próxima página"
            />
          </>
        ) : (
          <Loader />
        )}
      </div>
    </section>
  );
};

export default ProductsSection;
